var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"yourcx-survey",attrs:{"id":"yourcx.insert"}})
}
var staticRenderFns = []

export { render, staticRenderFns }